import React, { useEffect, useState } from "react";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Validate from "./../../component/Authvalidate";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Common from "./../../common.json";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});
export default function MarketSignal() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [column, setcolumn] = useState(1);
  const [extra_id, setextra_id] = React.useState("NIFTY");
  const [getDate, setdate] = React.useState(false);
  const [bsstatus, setbsstatus] = React.useState(1);
  const [getDetails, setDetails] = useState(false);
  const [arr, setarr] = useState(false);
  const [buyData, setbuyData] = useState(false);
  const [sellData, setsellData] = useState(false);

  useEffect(() => {
    setLoading(true);
    RestService.marketSignalData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (response.data.sellData) {
          setsellData(response.data.sellData);
        }
        if (response.data.buyData) {
          setbuyData(response.data.buyData);
          setarr(response.data.buyData);
        }
        if (response.data.getDetails) {
          setDetails(response.data.getDetails);
        }

        //setglobaldata(response.data.response);
      },
      mobile,
      web_token,
      extra_id,
      getDate
    );
  }, [column, mobile, web_token, extra_id, getDate]);
  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  function selectDate(e) {
    let newdate = e.target.value;

    setdate(newdate);
  }

  function handlebsclick(val) {
    if (val === 1) {
      setarr(buyData);
    } else {
      setarr(sellData);
    }
    setbsstatus(val);
  }
  function handleclick(val) {
    setextra_id(val);
  }
  const getUpdatedData = () => {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  };
  return (
    <>
      <Validate />
      <GlobalHelmet {...Common?.marketSignal} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-lg-12">
              <Breadcrumbs page="Nifty Signal" />

              <div className={classes.root}>
                <div className=" ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="">
                        <div className="row mb-2">
                          <div className="col-md-6 col-8">
                            <h3>
                              <span className="highlighttext">
                                Nifty Signal
                              </span>{" "}
                            </h3>
                          </div>
                          <div className="col-md-6 col-4 text-right">
                            <button
                              className="btn btn-success"
                              title="Reload Page"
                              onClick={refreshPage}
                            >
                              <i className="fa fa-refresh"></i>
                            </button>{" "}
                            &nbsp;
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-6 pt-2">
                            <p>
                              <button
                                className={
                                  extra_id === "NIFTY"
                                    ? "btn btn-success"
                                    : "btn btn-default"
                                }
                                onClick={(event) => handleclick("NIFTY")}
                              >
                                Nifty
                              </button>{" "}
                              &nbsp;
                              <button
                                className={
                                  extra_id === "BANKNIFTY"
                                    ? "btn btn-danger"
                                    : "btn btn-default"
                                }
                                onClick={(event) => handleclick("BANKNIFTY")}
                              >
                                {" "}
                                Bank Nifty
                              </button>
                              &nbsp;
                            </p>
                            <p>
                              <button
                                className={
                                  bsstatus === 1
                                    ? "btn btn-success"
                                    : "btn btn-default"
                                }
                                onClick={(event) => handlebsclick(1)}
                              >
                                Buy{" "}
                              </button>
                              &nbsp;
                              <button
                                className={
                                  bsstatus === 2
                                    ? "btn btn-danger"
                                    : "btn btn-default"
                                }
                                onClick={(event) => handlebsclick(2)}
                              >
                                {" "}
                                Sell{" "}
                              </button>
                              &nbsp;
                            </p>
                          </div>
                          <div className="col-lg-3 col-6 pt-2">
                            <TextField
                              onChange={selectDate}
                              id="date"
                              label="Select Date"
                              type="date"
                              defaultValue={getDate}
                              className={classes.textField}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>

                          <div className="col-lg-3 col-12 pt-2 mb-2 text-right">
                            <button
                              onClick={getUpdatedData}
                              className="btn  btn-success  "
                            >
                              Get Data
                            </button>
                          </div>

                          <div className="col-12 pl-4 pr-4 pb-4 mb-4  ">
                            {arr ? (
                              <div className="buysellData">
                                <div className="row green-border">
                                  <div className="col-12 fontwt">
                                    Intraday : {arr.buyORsell} :{" "}
                                    {arr.sb.toFixed(2)}
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-6">
                                    <div className="row">
                                      <div className="col-6 font-bold">
                                        T1 :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.t1.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        T2 :
                                      </div>
                                      <div className="col-6">
                                        {arr.t2.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        T3 :
                                      </div>
                                      <div className="col-6">
                                        {arr.t3.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="row">
                                      <div className="col-6 font-bold">
                                        SL :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.sl.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        {bsstatus === 1
                                          ? "Support"
                                          : "Resistance"}{" "}
                                        :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.support.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row green-border">
                                  <div className="col-12 fontwt">
                                    Short Term : {arr.buyORsell} :{" "}
                                    {arr.wsb.toFixed(2)}
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-6">
                                    <div className="row">
                                      <div className="col-6 font-bold">
                                        T1 :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.wt1.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        T2 :
                                      </div>
                                      <div className="col-6">
                                        {arr.wt2.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        T3 :
                                      </div>
                                      <div className="col-6">
                                        {arr.wt3.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="row">
                                      <div className="col-6 font-bold">
                                        SL :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.wsl.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        {bsstatus === 1
                                          ? "Support"
                                          : "Resistance"}{" "}
                                        :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.wsupport.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row green-border">
                                  <div className="col-12 fontwt">
                                    Long Term : {arr.buyORsell} :{" "}
                                    {arr.msb.toFixed(2)}
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-6">
                                    <div className="row">
                                      <div className="col-6 font-bold">
                                        T1 :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.mt1.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        T2 :
                                      </div>
                                      <div className="col-6">
                                        {arr.mt2.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        T3 :
                                      </div>
                                      <div className="col-6">
                                        {arr.mt3.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="row">
                                      <div className="col-6 font-bold">
                                        SL :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.msl.toFixed(2)}
                                      </div>
                                      <div className="col-6 font-bold">
                                        {bsstatus === 1
                                          ? "Support"
                                          : "Resistance"}{" "}
                                        :{" "}
                                      </div>
                                      <div className="col-6">
                                        {arr.msupport.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {getDetails ? (
                              <>
                                <table className="table table-bordered">
                                  <thead>
                                    <tr className="header-row changefont">
                                      <th className="indexname" size="3">
                                        Old Signal
                                      </th>
                                      <th className="ltp" size="3">
                                        New Signal
                                      </th>
                                      <th className="signal" size="3">
                                        Rec Price
                                      </th>
                                      <th className="change" size="3">
                                        Time
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {getDetails.map((item, key) => (
                                      <tr key={key}>
                                        <td>{item.oldsignal} </td>
                                        <td>{item.signal} </td>
                                        <td>{item.rec_price}</td>
                                        <td>{item.time}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
